module.exports = __webpack_public_path__ + "static/media/no_data.1a528323.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/user-new/no_data.png
// module id = 661
// module chunks = 0